module.exports = __webpack_public_path__ + "00096aff165f9dbea138e9262e24215a.svg";